import React from 'react';
import styles from './Toast.module.css';

export function ToastContainer({ toasts, onDismiss }) {
  if (!toasts.length) return null;
  return (
    <div className={styles.container}>
      {toasts.map(t => (
        <div key={t.id} className={`${styles.toast} ${styles[t.type]}`}>
          <span className={styles.icon}>
            {t.type === 'success' ? '✓' : t.type === 'error' ? '✕' : 'ℹ'}
          </span>
          <span className={styles.text}>{t.text}</span>
          <button className={styles.dismiss} onClick={() => onDismiss(t.id)}>✕</button>
        </div>
      ))}
    </div>
  );
}
